import { makeStyles } from '@material-ui/core'

const styles = ({ clientPortalTheme }) =>
  makeStyles((theme) => ({
    buttonPrimary: {
      padding: theme.spacing(1.5, 2),
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(15),
      backgroundColor: theme.palette.primary.main,
      color: !!clientPortalTheme
        ? theme.palette.primary.contrastText
        : theme.palette.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  }))

export default styles
